import { RouterManager } from '@aclass/admin/managers';
import { OpportunityStory } from '@aclass/admin/storage/actions';
import { IAdminState, IOpportunityModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class OpportunitySearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:opportunity-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IOpportunityModuleState['searchPageInitialized']>(['opportunityModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(OpportunitySearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(OpportunityStory.dryRunSearchPage());
    }
}
